"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncManifestArguments = exports.SyncManifestOptions = void 0;
exports.SyncManifestOptions = [
    {
        name: "projectPath",
        type: "string",
        description: "Project Path",
        required: true,
        default: "./",
    },
    {
        name: "env",
        type: "string",
        description: "Target Microsoft 365 Agents Toolkit Environment",
        required: true,
    },
    {
        name: "teams-app-id",
        type: "string",
        description: "App ID (optional)",
        required: true,
    },
];
exports.SyncManifestArguments = [];
//# sourceMappingURL=SyncManifestOptions.js.map